module.exports = __webpack_public_path__ + "img/Group 2.86b2f909.svg";